
import { X } from "lucide-react";

const AthletesModal = ({ data, onClose }) => {

  const participants = data?.athletes ?? [];
  const totalAthletesCount = data?.athletes?.length

  return (
    <div className="training-modal-overlay">

      <div className="training-modal participants-modal">

        {/* HEADER */}
        <div className="modal-header" style={{'padding':'0px'}}>
          <h5>Athletes ({totalAthletesCount})</h5>

          <button className="icon-btn" onClick={onClose}>
            <X size={18} />
          </button>
        </div>


        {/* TABLE */}
        <div className="table-wrapper">

          <table className="table participants-table">

            <thead>
              <tr>
                <th>Athletes Name</th>
                <th>Sport</th>
              </tr>
            </thead>

            <tbody>

              {participants?.length > 0 ? (
                participants?.map((p, i) => (
                  <tr key={p?.id}>
                    <td>{p?.first_name + ' ' + p?.last_name}</td>
                    <td>{p?.sport_name}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center">
                    No Athletes found
                  </td>
                </tr>
              )}

            </tbody>

          </table>

        </div>

      </div>
    </div>
  );
};

export default AthletesModal;